import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Soft page-enter animation on route changes for the main content area.
 */
function PageEnter({ children }) {
  const location = useLocation();
  const [animKey, setAnimKey] = useState(location.pathname);

  useEffect(() => {
    setAnimKey(location.pathname);
  }, [location.pathname]);

  return (
    <div key={animKey} className="ch-page-enter">
      {children}
    </div>
  );
}

export default PageEnter;
